enum Color {
  Inherit = 'inherit',
  Primary = 'primary',
  Secondary = 'secondary',
}

export default Color
